export default __webpack_public_path__ + "static/media/other-icon.d43ffe5a.png";